module.exports = __webpack_public_path__ + "static/media/team-block-bg.5fd3b72c.jpg";